import defaultStates from '@/constants/lifecycle';

const workflowActions = {
  REFRESH_WORKFLOWS: 'REFRESH_WORKFLOWS',
  FETCH_WORKFLOWS: 'FETCH_WORKFLOWS',
  SHOW_WORKFLOWS: 'SHOW_WORKFLOWS',
  SHOW_WORKFLOWS_ERROR: 'SHOW_WORKFLOWS_ERROR',
  FETCH_WORKFLOW: 'FETCH_WORKFLOW',
  SHOW_WORKFLOW: 'SHOW_WORKFLOW',
  SHOW_WORKFLOW_ERROR: 'SHOW_WORKFLOW_ERROR',
  CLOSE_WORKFLOWS: 'CLOSE_WORKFLOWS',
  CLOSE_WORKFLOW: 'CLOSE_WORKFLOW',
};

export const workflowStates = {
  ...defaultStates,
};

export const controlsRequestsTypes = {
  FAIR: 'fair',
  WORKFLOW: 'workflow',
  EXTERNAL: 'external',
};

export default workflowActions;
